//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let outerStyleHeight = `100vh`;
	let outerStylePaddingY = minimumMarginX;
	let mainTitleTextFontSize = `5rem`;
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
		mainTitleTextFontSize = `3rem`;
	}
	if (size === 'md') {
		mainTitleTextFontSize = `3rem`;
	}
	if (size === 'sm') {
		mainTitleTextFontSize = `3rem`;
	}
	if (isMobile) {
		mainTitleTextFontSize = `2rem`;
		outerStyleHeight = `auto`;
		outerStylePaddingY = 5;
	}
	//#endregion

	return {
		outerStyle: bg => {
			return {
				display: 'flex',
				flexDirection: 'column',
				height: outerStyleHeight,
				backgroundImage: `url(${bg})`,
				padding: `${outerStylePaddingY}rem ${minimumMarginX}rem`,
				backgroundSize: `cover`,
				width: `100%`,
			};
		},
		titleSyle: () => {
			return {
				textAlign: 'center',
				fontSize: mainTitleTextFontSize,
			};
		},
		genericTextStyle: () => {
			return {
				color: `white`,
				marginTop: `1rem`,
			};
		},
		contentContainerStyle: () => {
			return {
				width: `100%`,
				display: 'flex',
				flexDirection: 'column',
				height: `auot`,
				margin: `auto`,
			};
		},
	};
}

export default Styles;
